import axios from 'axios'
import ENV from '../env'
import Auth from '../models/auth'
import router from '../router'

export default {

  install: (Vue) => {
    Vue.prototype.api = {
      get (uri, data) {
        return this.call('get', uri, data)
      },
      post (uri, data) {
        return this.call('post', uri, data)
      },
      put (uri, data) {
        return this.call('put', uri, data)
      },
      patch (uri, data) {
        return this.call('patch', uri, data)
      },
      delete (uri, data) {
        return this.call('delete', uri, data)
      },
      multipart (uri, data) {
        let formData = new FormData()

        for (let param in data) {
          if (data[param] !== null && data[param] !== undefined) {
            // If is a file or a a value
            if (data[param] instanceof File || !(data[param] instanceof Object)) {
              formData.append(param, data[param])
            } else {
              for (let arrayParam in data[param]) {
                formData.append(param + '[' + arrayParam + ']', data[param][arrayParam])
              }
            }
          }
        }

        return this.call('post', uri, formData)
      },

      refreshToken (method, uri, data) {
        return new Promise((resolve, reject) => {
          console.log('REFRESHING ACCESS TOKEN...')

          this.call('put', '/api/v1/session', null, true).then(response => {
            Auth.setAuthorization(response.data.authorization)

            this.call(method, uri, data).then(response => {
              resolve(response)
            })
          })
        })
      },

      call (method, uri, data, refreshingToken) {
        Event.$emit('showLoading')

        return new Promise((resolve, reject) => {
          let headers = {
            'Content-Type': ENV.headers['Content-Type'],
            Accept: ENV.headers.Accept,
            userAccess: Auth.getAuthorization()
          }

          axios({
            method: method,
            url: ENV.api.url + uri,
            headers,
            data: data,
            validateStatus () {
              return true
            }
          }).then(response => {
            Event.$emit('closeLoading')

            if (ENV.debug) {
              console.log(method + ' call to ' + ENV.api.url + uri)
              console.log('HEADERS: ')
              console.log(headers)
              console.log('RESPONSE: ')
              console.log(response)
              console.log('DATA: ')
              console.log(response.data)
            }

            if (response.status === 401) {
              // window.location.href = 'login'
              router.push('login')
              return
            } else if (response.status < 200 || response.status > 401) {
              Event.$emit('showModal', response.data.message)
              return
            }

            resolve(response.data)
          }).catch(error => {
            Event.$emit('closeLoading')
            console.log(error)
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/api.js